import React from 'react';
import PropTypes from 'prop-types';

import SymptomTreeItem from './SymptomTreeItem';
import MedicalContentTreeItem, { useMedicalContentTreeItem } from '../_common/MedicalContentTreeItem';

import { useApiClient } from '../../context/ApiClientContext';
import SymptomParentPane from './SymptomParentPane';

export default function SymptomParentTreeItem(props) {
  const { setFormPane, setTreeManagementServices } = props;
  const {
    MCTreeItemLabel,
    MCTreeItemChildNodes,
    expand,
    setExpand,
    setMCTreeItemChildNodes,
  } = useMedicalContentTreeItem('Symptoms');

  const apiClient = useApiClient();

  const fetchChildNodes = async () => {
    const results = await apiClient.getSymptoms();
    setMCTreeItemChildNodes(results.data.map((sx) => (
      <SymptomTreeItem
        key={`${sx.medicalName}_${sx.id}`}
        symptomId={sx.id}
        label={sx.medicalName}
        setFormPane={setFormPane}
        setTreeManagementServices={setTreeManagementServices}
        refreshParent={fetchChildNodes}
      />
    )));
  };

  const reloadAndExpandNode = () => {
    fetchChildNodes();
    setExpand(true);
  };

  const onSelect = () => {
    setFormPane(
      <SymptomParentPane
        refreshParent={reloadAndExpandNode}
      />,
    );
    setTreeManagementServices({});
  };

  return (
    <MedicalContentTreeItem
      id={0}
      MCTreeItemLabel={MCTreeItemLabel}
      MCTreeItemChildNodes={MCTreeItemChildNodes}
      fetchChildNodes={fetchChildNodes}
      onSelect={onSelect}
      expand={expand}
      textToDisplayIfNoChildren="No symptoms yet..."
    />
  );
}

SymptomParentTreeItem.propTypes = {
  setFormPane: PropTypes.func.isRequired,
  setTreeManagementServices: PropTypes.func.isRequired,
};
